// Internal Module Imports
import { BASE_URL_BIDDING_SERVICE } from '../../constants';
import { HttpClient } from '../../utils/httpClient';

const PATH = {
    create: `/${BASE_URL_BIDDING_SERVICE}/client/bid-request`,
    update: `/${BASE_URL_BIDDING_SERVICE}/client/bid-request`,
    get: `/${BASE_URL_BIDDING_SERVICE}/client/bid-request`,
    delete: `/${BASE_URL_BIDDING_SERVICE}/client/bid-request`,
};

const CreateRequest = (body, start, callback, error, next) => {
    start();
    return HttpClient.post(`${PATH.create}`, body).then(callback).catch(error).finally(next);
};

const UpdateRequest = (id, body, start, callback, error, next) => {
    start();
    return HttpClient.patch(`${PATH.update}/${id}`, body).then(callback).catch(error).finally(next);
};

const GetRequest = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.get}`, { params }).then(callback).catch(error).finally(next);
};

const DeleteRequest = (id, start, callback, error, next) => {
    start();
    return HttpClient.delete(`${PATH.delete}/${id}`).then(callback).catch(error).finally(next);
};

export const BidRequestService = {
    CreateRequest,
    UpdateRequest,
    GetRequest,
    DeleteRequest,
};
